import { TEST } from "../../../data/page_types"

export default () =>
  window.location.host.toLowerCase().includes(`${TEST}-`) ||
  window.location.host.toLowerCase().includes(".localhost")
  